/* LUNEXUS Warm – Produktseite (v2b). Ohne Abhängigkeiten; Warenkorb über Horizon-Events (@shopify/events). */
const root = document.querySelector('[data-lxp]');
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
const MONEY = (root && root.dataset.money) || '{{amount_with_comma_separator}} €';
const fmt = (c) => {
  const [i, d] = (Math.round(c) / 100).toFixed(2).split('.');
  const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
  const dot = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
  return MONEY.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount_no_decimals\w*\s*\}\}/, i).replace(/\{\{\s*amount\s*\}\}/, dot);
};

const T = (k, d) => (root && root.dataset['t' + k]) || d;
if (root) {
  let base = +root.dataset.price || 0;
  const tiers = (root.dataset.tiers || '').split(',').map((t) => t.split(':').map(Number)).filter((t) => t[0] > 0).sort((a, b) => b[0] - a[0]);
  const showTiers = root.dataset.showTiers === 'true';
  const unit = (n) => { for (const [min, pct] of tiers) if (n >= min) return { d: pct, c: base - Math.floor((base * pct) / 100) }; return { d: 0, c: base }; }; /* Rundung wie Shopify: Rabatt je Stück abgerundet */

  /* ── Galerie ── */
  const track = $('[data-lxp-track]', root);
  const slides = track ? $$('.lxp-slide', track) : [];
  const thumbs = $$('.lxp-thumbs button', root);
  const count = $('[data-lxp-count]', root);
  let cur = 0;
  const mark = (i) => { cur = i; thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false')); if (count) count.textContent = i + 1 + ' / ' + slides.length; const th = thumbs[i]; if (th) th.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' }); };
  const go = (i) => { if (!track) return; i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); mark(i); };
  if (track) {
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) mark(i); }); }, { passive: true });
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(cur + (e.key === 'ArrowRight' ? 1 : -1)); } });
  }
  thumbs.forEach((b, i) => b.addEventListener('click', () => go(i)));

  /* Lightbox (Pinch nativ, Tippen = 2×) */
  const lb = $('[data-lxp-lb]', root);
  const lbImg = lb && $('[data-lxp-lbimg]', lb);
  const openLb = () => { if (!lb || !slides[cur]) return; const im = $('img', slides[cur]); lbImg.src = slides[cur].dataset.full || (im && im.currentSrc) || ''; lbImg.alt = im ? im.alt : ''; lbImg.classList.remove('is-z'); lb.showModal(); };
  slides.forEach((s) => s.addEventListener('click', openLb));
  const zb = $('[data-lxp-zoom]', root);
  if (zb) zb.addEventListener('click', openLb);
  if (lb) {
    lbImg.addEventListener('click', () => lbImg.classList.toggle('is-z'));
    $('[data-lxp-lbclose]', lb).addEventListener('click', () => lb.close());
    lb.addEventListener('click', (e) => { if (e.target === lb) lb.close(); });
  }

  /* ── Akkordeon per Link öffnen ── */
  $$('[data-lxp-open]').forEach((a) => a.addEventListener('click', (e) => {
    const d = document.getElementById(a.dataset.lxpOpen);
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    const s = $('summary', d); if (s) s.focus({ preventScroll: true });
  }));

  /* ── Menge + Ersparnis ── */
  const form = $('[data-lxp-form]', root);
  const msg = $('[data-lxp-msg]', root);
  const qty = $('[data-lxp-qty]', root);
  const sv = $('[data-lxp-savings]', root);
  const gq = $('[data-lxp-gq]', root);
  const out = $('[data-lxp-calcout]', root);
  const clamp = (n) => Math.max(1, Math.min(999, parseInt(n, 10) || 1));
  const calc = (n) => {
    if (!out) return;
    const u = unit(n);
    const minT = tiers.length ? tiers[tiers.length - 1][0] : 10;
    const tb = (out.dataset.tBase || 'Ab {{ min }} Stück greift eure Mengenstaffel.').replace(/\{\{\s*min\s*\}\}/, minT);
    const ts = out.dataset.tSave || 'ihr spart';
    out.innerHTML = u.d === 0
      ? `${n} × ${fmt(base)} = <b>${fmt(base * n)}</b>. ${tb}`
      : `${n} × ${fmt(u.c)} = <b>${fmt(u.c * n)}</b> · <span class="s">${ts} ${fmt((base - u.c) * n)} (${u.d} %)</span>`;
    $$('[data-lxp-tiers] tbody tr', root).forEach((r) => r.classList.remove('is-on'));
    const rows = $$('[data-lxp-tiers] tbody tr', root).reverse();
    for (const r of rows) if (n >= +r.dataset.min) { r.classList.add('is-on'); break; }
  };
  const updUnits = () => $$('[data-lxp-tiers] tbody tr', root).forEach((r) => { const c = $('[data-lxp-unit]', r); if (c) c.textContent = fmt(base - Math.floor((base * +r.dataset.pct) / 100)); });
  const onQty = () => {
    const n = clamp(qty.value);
    if (!showTiers || !sv) return;
    const u = unit(n);
    /* nur für freigeschaltete Gemeinde-Kunden (data-show-tiers kommt aus Liquid: customer.tags contains 'gemeinde') */
    if (u.d > 0) { sv.hidden = false; sv.textContent = `${n} × ${fmt(u.c)} = ${fmt(u.c * n)} · ${(out && out.dataset.tSave) || 'ihr spart'} ${fmt((base - u.c) * n)} (${u.d} %)`; if (gq) { gq.value = n; calc(n); } }
    else sv.hidden = true;
  };
  /* Staffel 19.10.2026: Paket-Schnellwahl 1 / 2 (−10 %) / 5 (−15 %) – setzt nur die Menge; Rundung wie Shopify (Rabatt je Stück abgerundet) */
  const packs = $$('[data-lxp-pack]', root);
  const markPacks = () => { const n = clamp(qty ? qty.value : 1); packs.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.lxpPack === n))); };
  const updPacks = () => packs.forEach((b) => {
    const n = +b.dataset.lxpPack, u = base - Math.floor((base * +b.dataset.pct) / 100);
    const t = $('[data-lxp-packt]', b), o = $('[data-lxp-packo]', b);
    if (t) t.textContent = fmt(u * n); if (o) o.textContent = fmt(base * n);
  });
  if (qty) {
    $$('[data-lxp-q]', root).forEach((b) => b.addEventListener('click', () => { qty.value = clamp((+qty.value || 1) + +b.dataset.lxpQ); onQty(); markPacks(); }));
    qty.addEventListener('change', () => { qty.value = clamp(qty.value); onQty(); markPacks(); });
    qty.addEventListener('input', markPacks);
    packs.forEach((b) => b.addEventListener('click', () => { qty.value = b.dataset.lxpPack; onQty(); markPacks(); }));
  }
  if (gq) {
    gq.addEventListener('input', () => calc(clamp(gq.value)));
    $$('[data-lxp-g]', root).forEach((b) => b.addEventListener('click', () => { gq.value = clamp((+gq.value || 1) + +b.dataset.lxpG); calc(+gq.value); }));
    calc(clamp(gq.value));
  }

  /* ── Varianten ── */
  const vjson = $('[data-lxp-variants]', root);
  const variants = vjson ? JSON.parse(vjson.textContent) : [];
  const vid = $('[data-lxp-vid]', root);
  const addBtns = $$('[data-lxp-add]');
  const addTxt = $('[data-lxp-addtxt]', root);
  const ADD = T('Add', 'In den Warenkorb'), SOLD = T('Soldout', 'Gerade ausverkauft'), SOLDS = T('SoldoutShort', 'Ausverkauft'), NOC = T('Nocombo', 'Diese Kombination gibt es nicht');
  /* state: 'ok' | 'sold' | 'none' (Kombination existiert nicht) */
  const setAvail = (state) => {
    const ok = state === 'ok';
    addBtns.forEach((b) => { b.disabled = !ok; });
    const txt = ok ? ADD : state === 'none' ? NOC : SOLD;
    if (addTxt) addTxt.textContent = txt;
    const sb = $('.lxp-sbar .lx-btn'); if (sb) sb.textContent = ok ? ADD : state === 'none' ? NOC : SOLDS;
  };
  const cmp = $('[data-lxp-compare]', root);
  const fieldsets = $$('.lxp-opt', root);
  const curSel = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
  /* Werte je Option live neu bewerten: is-nx = gibt es mit der übrigen Auswahl nicht, is-na = gibt es, aber ausverkauft */
  const markOpts = (sel) => {
    fieldsets.forEach((fs, i) => {
      $$('.lxp-optbtn', fs).forEach((lab) => {
        const val = $('input', lab).value;
        const m = variants.filter((x) => x.o[i] === val && x.o.every((o, j) => j === i || sel[j] == null || o === sel[j]));
        lab.classList.toggle('is-nx', m.length === 0);
        lab.classList.toggle('is-na', m.length > 0 && !m.some((x) => x.a));
      });
    });
  };
  if (variants.length) {
    /* gewählte Variante in der wischbaren Zeile sichtbar machen (mobil) */
    $$('.lxp-opt__vals', root).forEach((row) => { const c = $('input:checked', row); if (c && row.scrollWidth > row.clientWidth) { const l = c.closest('label'); row.scrollLeft = Math.max(0, l.offsetLeft - row.offsetLeft - 16); } });
    markOpts(curSel());
    root.addEventListener('change', (e) => {
      if (!e.target.matches('[data-lxp-opt]')) return;
      const sel = curSel();
      $$('[data-lxp-optval]', root).forEach((b) => { b.textContent = sel[+b.dataset.lxpOptval] || ''; });
      markOpts(sel);
      const v = variants.find((x) => x.o.every((o, i) => o === sel[i]));
      if (!v) { setAvail('none'); if (msg) msg.textContent = T('NocomboHint', NOC); return; }
      if (msg) msg.textContent = '';
      vid.value = v.id;
      base = v.p;
      $$('[data-lxp-price]').forEach((el) => { el.textContent = fmt(v.p); });
      if (cmp) { if (v.c && v.c > v.p) { cmp.textContent = fmt(v.c); cmp.hidden = false; } else { cmp.textContent = ''; cmp.hidden = true; } }
      $$('[data-lxp-sku]', root).forEach((el) => { el.textContent = v.s || ''; });
      const ean = $('[data-lxp-ean]', root), eanRow = $('[data-lxp-ean-row]', root);
      if (ean) ean.textContent = v.e || ''; if (eanRow) eanRow.hidden = !v.e;
      setAvail(v.a ? 'ok' : 'sold');
      updUnits(); updPacks(); onQty(); if (gq) calc(clamp(gq.value));
      if (v.m) { const i = slides.findIndex((s) => s.dataset.mediaId == v.m); if (i > -1) go(i); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
    });
  }

  /* ── In den Warenkorb (AJAX + Horizon-Drawer) ── */
  if (form) form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = $('.lxp-add', root);
    if (btn.disabled || form.dataset.lxBusy) return; /* Leck-Audit 15.10.: kein Doppel-Add bei Mehrfach-Tippen */
    form.dataset.lxBusy = '1';
    addBtns.forEach((b) => b.setAttribute('aria-busy', 'true'));
    msg.textContent = '';
    const fd = new FormData();
    fd.append('id', vid.value);
    fd.append('quantity', String(clamp(qty ? qty.value : 1)));
    const secIds = $$('cart-items-component').map((c) => c.dataset.sectionId).filter(Boolean);
    if (secIds.length) fd.append('sections', secIds.join(','));
    let ev = null, deferred = null;
    try { ev = await import('@shopify/events'); } catch (_) { ev = null; }
    if (ev && ev.CartLinesUpdateEvent) {
      deferred = ev.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: vid.value, quantity: +fd.get('quantity') }], promise: deferred.promise }));
    }
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const j = await r.json();
      const cart = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then((x) => x.json());
      if (!r.ok || j.status) {
        msg.textContent = j.description || j.message || T('Err', 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
        if (deferred) deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'lx-pdp' } });
      } else {
        if (deferred) deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false, items: cart.items, source: 'lx-pdp', sections: j.sections, itemCount: +fd.get('quantity'), productId: root.dataset.productId } });
        btn.classList.add('is-done');
        if (addTxt) addTxt.textContent = T('Added', 'Im Warenkorb ✓');
        setTimeout(() => { btn.classList.remove('is-done'); if (addTxt && !btn.disabled) addTxt.textContent = ADD; }, 2200);
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') setTimeout(() => { try { if (!drawer.isOpen) drawer.open(); } catch (_) {} }, 150);
        else if (!drawer) { if (!deferred) location.href = '/cart'; }
      }
    } catch (err) {
      msg.textContent = T('Offline', 'Keine Verbindung. Bitte versuch es noch einmal.');
      if (deferred) deferred.reject(err);
    } finally {
      addBtns.forEach((b) => b.removeAttribute('aria-busy'));
      delete form.dataset.lxBusy;
    }
  });

  /* ── Sticky-Kaufleiste: sichtbar, sobald der Haupt-CTA NICHT im Bild ist (oberhalb ODER noch unterhalb, FIX5/PDP-05) ── */
  const sbar = $('[data-lxp-sbar]', root);
  const cta = $('[data-lxp-cta]', root);
  if (sbar && cta && 'IntersectionObserver' in window) {
    document.body.appendChild(sbar);
    new IntersectionObserver((es) => es.forEach((e) => {
      const show = !e.isIntersecting;
      sbar.classList.toggle('is-on', show);
      if (show) sbar.removeAttribute('inert'); else sbar.setAttribute('inert', '');
    })).observe(cta);
  }
  if (lb) document.body.appendChild(lb);
}

/* ── Leisten (FIX5):
   „Passt dazu“ = kuratiertes Metafeld shopify--discovery--product_recommendation.complementary_products (serverseitig gerendert);
   sonst intent=complementary (gleiche Quelle über die API). KEIN Auffüllen mit „related“ (das brachte fachfremde Artikel).
   „Ähnliche“ = intent=related, gefiltert auf denselben typ:-Tag (sonst gleicher heilige:-Tag); reicht das nicht, bleibt die Leiste aus. ── */
const rails = document.querySelector('[data-lxp-rails]');
if (rails) {
  const load = async () => {
    const pid = rails.dataset.productId;
    const isFigur = rails.dataset.figur === 'true';
    const typ = rails.dataset.typ || '';
    const heil = (rails.dataset.heilige || '').split('|').filter(Boolean);
    const base = rails.dataset.url || '/recommendations/products';
    const get = async (intent, limit) => {
      try {
        const r = await fetch(`${base}?product_id=${pid}&limit=${limit}&intent=${intent}&section_id=lx-pdp-recs`);
        if (!r.ok) return [];
        const d = document.createElement('div');
        d.innerHTML = await r.text();
        return Array.from(d.querySelectorAll('.lxp-pcard')).filter((c) => c.dataset.pid !== pid);
      } catch (_) { return []; }
    };
    const fitSec = rails.querySelector('[data-lxp-rail="fit"]');
    const fitDone = fitSec && fitSec.dataset.server === 'true';
    const [comp, rel] = await Promise.all([fitDone ? Promise.resolve([]) : get('complementary', 6), get('related', 10)]);
    const seen = new Set();
    if (fitDone) fitSec.querySelectorAll('.lxp-pcard').forEach((c) => seen.add(c.dataset.pid));
    const take = (list, n, filter) => { const o = []; for (const c of list) { if (o.length >= n) break; if (seen.has(c.dataset.pid) || (filter && !filter(c))) continue; seen.add(c.dataset.pid); o.push(c); } return o; };
    const sameFig = (c) => (c.dataset.figur === 'true') === isFigur;
    let alt = typ ? take(rel, 4, (c) => sameFig(c) && c.dataset.typ === typ) : [];
    if (alt.length < 2 && heil.length) alt = alt.concat(take(rel, 4 - alt.length, (c) => sameFig(c) && (c.dataset.heilige || '').split('|').some((h) => heil.includes(h))));
    const noFig = isFigur ? null : (c) => c.dataset.figur !== 'true';
    const fit = fitDone ? [] : take(comp, 4, noFig);
    const fill = (key, cards) => {
      const sec = rails.querySelector(`[data-lxp-rail="${key}"]`);
      if (!sec || cards.length < 2) return;
      const t = sec.querySelector('[data-lxp-rtrack]');
      cards.forEach((c) => t.appendChild(c));
      sec.hidden = false;
    };
    fill('fit', fit);
    fill('alt', alt);
  };
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
    io.observe(rails);
  } else load();
}

/* ── Cross-Selling „Passt dazu“ (lx.xsell.*): Schnell-Hinzufügen + Desktop-Pfeile ──
   Hinzufügen wie der Haupt-Button: /cart/add.js + CartLinesUpdateEvent (Horizon aktualisiert Drawer/Zähler), danach Drawer öffnen,
   damit der Kunde den 10-%-Staffelrabatt sofort sieht. */
const xs = document.querySelector('[data-lxx]');
if (xs) {
  const track = xs.querySelector('.lxx-track');
  const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  const navBox = xs.querySelector('.lxx-nav');
  const navFit = () => { if (navBox && track) navBox.style.visibility = track.scrollWidth > track.clientWidth + 4 ? '' : 'hidden'; };
  navFit(); window.addEventListener('resize', navFit, { passive: true });
  xs.addEventListener('click', async (e) => {
    const nav = e.target.closest('[data-lxx-nav]');
    if (nav && track) { track.scrollBy({ left: (+nav.dataset.lxxNav) * track.clientWidth * 0.75, behavior: 'smooth' }); return; }
    const btn = e.target.closest('[data-lxx-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    const txt = btn.querySelector('[data-lxx-txt]');
    const old = txt ? txt.textContent : '';
    const fd = new FormData();
    fd.append('id', btn.dataset.vid);
    fd.append('quantity', '1');
    const secIds = Array.from(document.querySelectorAll('cart-items-component')).map((c) => c.dataset.sectionId).filter(Boolean);
    if (secIds.length) fd.append('sections', secIds.join(','));
    let ev = null, deferred = null;
    try { ev = await import('@shopify/events'); } catch (_) { ev = null; }
    if (ev && ev.CartLinesUpdateEvent) {
      deferred = ev.CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: btn.dataset.vid, quantity: 1 }], promise: deferred.promise }));
    }
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const j = await r.json();
      const cart = await fetch(root + 'cart.js').then((x) => x.json());
      const bad = !r.ok || j.status;
      if (deferred) deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: !!bad, items: cart.items, source: 'lx-xsell', sections: bad ? undefined : j.sections, itemCount: 1, productId: btn.closest('[data-pid]')?.dataset.pid } });
      if (bad) { if (txt) txt.textContent = track?.dataset.lxxErr || '!'; setTimeout(() => { if (txt) txt.textContent = old; btn.disabled = false; }, 2500); return; }
      btn.classList.add('is-done');
      if (txt) txt.textContent = track?.dataset.lxxAdded || '✓';
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') setTimeout(() => { try { if (!drawer.isOpen) drawer.open(); } catch (_) {} }, 150);
      else if (!drawer && !deferred) location.href = root + 'cart';
      setTimeout(() => { btn.classList.remove('is-done'); if (txt) txt.textContent = old; btn.disabled = false; }, 2600);
    } catch (err) {
      if (deferred) deferred.reject(err);
      if (txt) txt.textContent = old; btn.disabled = false;
    } finally { btn.removeAttribute('aria-busy'); }
  });
}
